import React from 'react';
import { useSelector } from 'react-redux';
import { Forms, Loading, SystemText } from '@salesperformanceint/e4shared';
import Filters from '../_filters';
import GroupPicker from 'components/admin/forms/groupPicker';
import Board from './board';
import WidgetBase, { groupSet, widgetLoad, widgetLoadRecommendations } from '../_base';
import MetricRecommendations from '../components/metricRecommendations';

export const FocusCompetencies = ({ defaultProps, id, item, setItem, onDelete }) => {
    const showFilters = useSelector(state => state.ui.filterWidget);
    const user = useSelector(state => state.user.user);
    const [type, setType] = React.useState('AVG');
    const [values, setValues] = React.useState({});
    const [errors, setErrors] = React.useState({});
    const [notConfigured, setNotConfigured] = React.useState(false);
    const [initialised, setInitialised] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [recLoading, setRecLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [recommendationData, setRecommendationData] = React.useState({});

    const defaults = { type: 'AVG' };

    React.useEffect(() => {
        if (item) {
            const parsed = JSON.parse(item.data);
            const all = { ...defaults, ...parsed };
            setValues(all);
            setType(all.type);
            setInitialised(true);
        }
    }, [item]);

    React.useEffect(() => {
        initialised && load();
    }, [initialised]);

    const load = () => {
        widgetLoad(item.id, user.guid, validator, setLoading, setNotConfigured, setData, () => {
            widgetLoadRecommendations(item.id, user.guid, setRecLoading, setRecommendationData);
        });
    };

    const updateProperty = (value, prop) => {
        const temp = { ...values };
        temp[prop] = value;
        setValues(temp);
    };

    const height = defaultProps.height(item);

    const validator = suppressErrors => {
        const form = values || JSON.parse(item.data);
        const errors = {};
        let validForm = true;

        if (!form.name) {
            errors.name = SystemText('Dashboard/Widgets/General/Edit/Fields/Name/Error');
            validForm = false;
        }

        if (!groupSet(form.group1)) {
            errors.group1 = SystemText('Dashboard/Widgets/FocusCompetencies/Fields/Group/Error');
            validForm = false;
        }

        if (!suppressErrors) setErrors(errors);
        return validForm;
    };

    const chart = (
        <div className="chart-container" id={`chart-${item.id}`} style={{ height: `${height}px` }}>
            <div className="chart" style={{ height: `${height}px` }}>
                <Board data={data} item={item} id={`chart-${item.id}`} type={type} />
            </div>
        </div>
    );

    const recommendations = () =>
        recLoading ? <Loading /> : <MetricRecommendations competencies={recommendationData?.results} />;

    const filters = values ? (
        <Filters
            validator={validator}
            widget={item}
            values={values}
            errors={errors}
            onChange={(value, prop) => updateProperty(value, prop)}
            refresh={x => {
                setItem(x);
                setType(values.type);
                load();
            }}
            show={showFilters === id}
            onDelete={onDelete}
        >
            <GroupPicker
                mandatory
                allowMultiple
                value={values.group1}
                error={errors.group1}
                onChange={value => updateProperty(value, 'group1')}
                showUserOption={defaultProps.company}
                controlId={id}
            />
            <Forms.Buttons
                label={SystemText('Dashboard/Widgets/FocusCompetencies/Fields/Type/Label')}
                help={SystemText('Dashboard/Widgets/FocusCompetencies/Fields/Type/Help')}
                error={errors.type}
            >
                <div className="btn-row">
                    <button
                        className={values.type === 'AVG' ? 'btn btn-primary' : 'btn btn-default'}
                        onClick={() => updateProperty('AVG', 'type')}
                        data-testid={`avg-rating-button`}
                    >
                        {SystemText('Dashboard/Widgets/FocusCompetencies/Fields/Type/Buttons/Average')}
                    </button>
                    <button
                        className={values.type === 'FLAG' ? 'btn btn-primary' : 'btn btn-default'}
                        onClick={() => updateProperty('FLAG', 'type')}
                        data-testid={`flag-button`}
                    >
                        {SystemText('Dashboard/Widgets/FocusCompetencies/Fields/Type/Buttons/Flagged')}
                    </button>
                </div>
            </Forms.Buttons>
        </Filters>
    ) : null;

    return (
        <WidgetBase
            filters={filters}
            chart={chart}
            height={height}
            item={item}
            recommendations={recommendations()}
            id={id}
            help={null}
            hideConfig={defaultProps.company && !user.administrator}
            extra={item.extra}
            loading={loading}
            notConfigured={notConfigured}
        />
    );
};

export default FocusCompetencies;
